module.exports = __webpack_public_path__ + "img/pie-chart-fill.f2ec5e73.svg";